import { css, cva } from '@/styled-system/css';

export const tourCardContainerRecipe = cva({
  base: {
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid {colors.border.subtle}',
    marginBottom: '50',
  },
  variants: {
    size: {
      sm: {},
      md: {
        maxWidth: '272px',
        lg: {
          width: '320px',
        },
      },
    },
    isSelected: {
      true: {
        boxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.2)',
      },
    },
    hasBigBottomBorder: {
      true: {
        borderBottom: '3px solid {colors.border.accent.brand.hero}',
        marginBottom: '0',
      },
    },
  },
});

export const emptyTourCardContainerStyles = css.raw({
  alignItems: 'center',
  borderRadius: '100',
  border: '1px solid {colors.border.subtle}',
  color: 'text.neutral',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  minHeight: '240px',
  maxHeight: '311px',
  padding: '400',
  textAlign: 'center',
});

export const tourCardSelectableControlsStyles = css.raw({
  display: 'flex',
  borderTop: '1px solid {colors.border.subtle}',
  padding: '{spacing.400} 0',
  marginBottom: '{spacing.-200}',
  marginTop: '200',
});

export const tourCardImageRecipe = cva({
  base: {
    position: 'relative',
    height: '140px',
  },
  variants: {
    size: {
      sm: {},
      md: {
        height: '170px',
      },
      full: {
        height: '100%',
      },
    },
    isClickable: {
      true: {
        cursor: 'pointer',
      },
      false: {},
    },
  },
});

export const tourCardImageOverlayStyles = css.raw({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(255, 255, 255, 0.8)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const tourCardImageHiddenStyles = css.raw({
  zIndex: 1,
  padding: '3px 7px',
  color: 'white',
  background: 'grey',
});

export const tourCardImageContainerStyles = css.raw({
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  backgroundColor: 'bg.softer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const tourCardImageSelectedStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '600',
  height: '600',
  position: 'absolute',
  borderRadius: '50%',
  boxShadow: 'rgba(0, 0, 0, 0.5) 0px 3px 9px 0px',
  zIndex: 1,
  top: '{spacing.200}',
  right: '{spacing.200}',
});
